import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  flex-direction: column;
`

export const Title = styled.h4`
  font-size: ${theme.colors.black};
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.medium};
  font-size: ${theme.font.sizes.medium};
  line-height: ${theme.font.sizes.large};
`

export const Subtitle = styled.h5`
  font-size: ${theme.colors.black};
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
`
